import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/transfer.svg";
var TransferSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  TransferSolid_default as default
};
